<template>
  <Modal
      :show.sync="isOpen"
      :on-close="onClose"
    >
    <div>
      <div class="mb_24">
        <h2 class="font_regular font_600 text_20">{{$t('COUPON.ADD_FORM.TYPE_FORM.PREVIEW.TITLE')}}</h2>
      </div>

      <MultiselectDropdown
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.TYPE.LABEL')"
      >
        <RadioList
          v-model="coupon.kind_index"
          :classWrapper="'couponOptions'"
          :options="coupon_types_formated"
        />
      </MultiselectDropdown>
      <InputField
        v-model="coupon.name"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.NAME.LABEL')"
        :disabled="true"
        :hint="$t('COUPON.ADD_FORM.TYPE_FORM.NAME.HINT')"
      />
      <InputField
        v-model="coupon.code"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.PROMO_CODE.LABEL')"
        :disabled="true"
        :hint="$t('COUPON.ADD_FORM.TYPE_FORM.PROMO_CODE.HINT')"
      />

      <MultiselectDropdown
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.DISCOUNT_TYPE.LABEL')"
      >
        <RadioList
          v-model="coupon.discount_type_index"
          :options="discount_types_formated"
          :classWrapper="'couponOptions'"
        />
      </MultiselectDropdown>
      <InputField
        v-model="coupon.discount_value"
        :disabled="true"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.VALUE_DISCOUNT.LABEL')"
        :textLength="coupon.discount_value"
        :classNamePostFix="'uppercase'"
        :postFix="coupon.discount_type_index === 0 ?'%': currentAccount.currency"
      />
      <div class="duration_wrap mb_16">
        <div :class="isRedemMultipleMonth? 'duration_fields':''">
          <MultiselectDropdown
            :label="$t('COUPON.ADD_FORM.TYPE_FORM.DURATION.LABEL')"
          >
            <multiselect
              class="column small-12"
              v-model="coupon.redeemed_type"
              :options="redeemed_list"
              track-by="id"
              label="title"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :disabled="true"
              :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.DURATION.PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            />
          </MultiselectDropdown>
          <InputField
            v-if="isRedemMultipleMonth"
            v-model="coupon.limit_per_month"
            :disabled="true"
            :label="$t('COUPON.ADD_FORM.TYPE_FORM.MONTHS.LABEL')"
            :textLength="coupon.limit_per_month"
            :postFix="$t('COUPON.ADD_FORM.TYPE_FORM.MONTHS.POST_FIX')"
          />
        </div>
      </div>
      <div>
        <label class="font_regular font_500 text_12 mb_8">
          {{$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LABEL')}}
        </label>
        <CheckboxInput
          v-model="coupon.date_range_limit"
          :classNameWrapper="'redemp_check_label'"
          :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_DATE.CHECKBOX_LABEL')"
          :disabled="true"
        />
        <div v-if="coupon.date_range_limit" class="ml_24">
          <MultiselectDropdown
            :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_DATE.LABEL')"
          >
          <div class="redemption">
              <WootDateTimePicker
                :value="coupon.redemp_date"
                style="margin-top:'8px'"
                :disable-dates="0"
                :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                displayFormat="ddd, DD MMM YYYY"
                type="date"
                :disabled="true"
              />
              <WootDateTimePicker
                :value="coupon.redemp_time"
                style="margin-top:'8px'"
                :disable-dates="0"
                :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                displayFormat="hh:mmA"
                type="time"
                :disabled="true"
              />
          </div>
          </MultiselectDropdown>
        </div>
      </div>
      <div v-if="coupon.is_redemp_limit">
        <CheckboxInput
          v-model="coupon.is_redemp_limit"
          :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.CHECKBOX_LABEL')"
          :classNameWrapper="'redemp_check_label'"
          :disabled="true"
        />
        <div class="redemption ml_24">
          <div>
            <InputField
            v-model="coupon.redeemed_limit"
            :label="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.LABEL')"
            :disabled="true"
            :textLength="coupon.redeemed_limit"
            :postFix="$t('COUPON.ADD_FORM.TYPE_FORM.REDEMPTION_LIMIT.POST_FIX')"
          />
          </div>
          <div></div>
        </div>
      </div>

      <div>
        <woot-button
          color-scheme="primary" size="small" :style="{width:'100%'}"
          variant="outline"
          :is-loading="uiFlags.isCreating || uiFlags.isUpdating"
          :is-disabled="uiFlags.isCreating || uiFlags.isUpdating"
          @click="onAddCoupon"
        >
          {{$t('COUPON.ADD_FORM.TYPE_FORM.BTNS.SAVE')}}
        </woot-button>
      </div>



    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '../../../../../components/Modal.vue';
import alertMixin from 'shared/mixins/alertMixin';
import RadioList from "../../../../dashboard/arrange/RadioList.vue"
import MultiselectDropdown from "../../../../../components/ui/inputs/MultiselectDropdown.vue"
import InputField from '../../../../../components/ui/inputs/InputField.vue';
import ToggleField from '../../../../../components/ui/inputs/ToggleField.vue';
import CheckboxInput from '../../../../../components/ui/inputs/CheckboxInput.vue';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import helperMixin from 'shared/mixins/helperMixin';


export default {
  components: {
    Modal,
    RadioList,
    MultiselectDropdown,
    InputField,
    ToggleField,
    CheckboxInput,
    WootDateTimePicker,
  },
  mixins: [alertMixin,helperMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    coupon:{
      type: Object,
    },
    kinds: {
      type: Array,
      default: [],
    },
    discount_types:{
      type: Array,
      default: []
    },
    redeemed_list:{
      type: Array,
      default: []
    },
  },
  data(){
    return {

    }
  },
  computed:{
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentUser: 'getCurrentUser',
      uiFlags: "coupons/getUIFlags",
      meta: "coupons/getMeta",
      coupons: "coupons/getCoupons",
    }),
    currentAccount(){
      return this.getAccount(this.currentUser.account_id);
    },
    coupon_types_formated(){
      return this.kinds.map(el=>({...el,disable:true}))
    },
    discount_types_formated(){
      return this.discount_types.map(el=>({...el,disable:true}))
    },
    isRedemMultipleMonth(){
      return this.coupon.redeemed_type?.id   === 'multiple_month';
    },
  },
  methods:{
    async onAddCoupon(){
      try {
        console.log(this.coupon);
        const {start_date:redemp_date,end_time:redemp_time} = this.formatStartEndDate(this.coupon.redemp_date,this.coupon.redemp_time);
        const payload = {
          kind: this.kinds[this.coupon.kind_index]?.id,
          code: this.coupon.code,
          name: this.coupon.name,
          products: this.coupon.products.map(el=>el.id),
          discount_type: this.discount_types[this.coupon.discount_type_index]?.id,
          discount_value: this.coupon.discount_value,
          redeemed_limit: this.coupon.redeemed_limit,
          redeemed_type: this.coupon.redeemed_type?.id,
          limit_per_month: this.coupon.limit_per_month,
          ...this.coupon.templates,
        }
        if (this.coupon.date_range_limit) {
          payload.expired_at= `${redemp_date} ${redemp_time}`;
        }
        if (this.coupon.id) {
          // add the staus as edit
          payload.status = this.coupon.status?.id;
        }

        // Create FormData
        const formData = new FormData();
        for (const key in payload) {
          const value = payload[key];
          if(key === 'products'){
            formData.append(key, value.join(','));
          }else{
            formData.append(key,value);
          }
        }
        // If the image is a file/blob, append it separately
        if (this.coupon.img_file.new_upload instanceof File || this.coupon.img_file.new_upload instanceof Blob) {
          formData.append("image", this.coupon.img_file.new_upload);
        }
        // Debug output
      console.log("FormData to send:", formData.get("payload_data"), formData.get("template_image"));


        if (this.coupon.id) {
          // dispatch edit
          await this.$store.dispatch("coupons/updateCouponById",{coupon_id:this.coupon.id,payload:formData,});
          this.$emit("onEdit")
        }else{
          await this.$store.dispatch("coupons/createCoupon",formData);
          this.$emit("onCreate")
        }
        // call api
        this.showAlert(this.$t('COUPON.ADD_FORM.TYPE_FORM.SUBMIT.SUCCESS_MSG'));
        // this.$router.push({name:"coupons_list"})
      } catch (error) {
        console.log(error.response);
        this.showErrAlert(error,this.$t('COUPON.ADD_FORM.TYPE_FORM.SUBMIT.SUCCESS_ERR'));
        // if (error.response?.data?.errors) {
        //   if (error.response?.data?.errors) {

        //   }
        // }
        // this.showAlert(message);
      }
    },
  },
}
</script>



<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.couponOptions{
  display: flex;
  gap: 24px;
}

.duration_wrap{
  .duration_fields{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 16px;
  }
}


.submit_btns{
  margin-top: 24px;
}
</style>

<style>
.couponOptions .radio-item{
  gap: 0;
}
.couponOptions .radio_label_wrap{
  margin-bottom: 2px;
}
.couponOptions .radio_label{
  font-weight: 500;
  color: #304352;
}
.couponOptions .radio_description{
  font-weight: 500;
  color: #858585;
  font-size: 12px;
}
</style>

<style>
.dropdown_slot .multiselect--disabled .multiselect__tags,
.dropdown_slot .multiselect--disabled .multiselect__tags .multiselect__single{
  background-color: #eee;
}
.dropdown_slot .date-picker .disabled input:disabled{
  background-color: #eee;
}
</style>